import _ from 'lodash';
import { delay } from '../delay';
import { MockDataStore } from './mock-data-store';

export class CompanyAPI {
    // This is a useless constructor right now, but its to keep it compatible with the real implementation of this API...
    // eslint-disable-next-line
    constructor(instance, inProgress, accounts, forceRefresh) {
        // Constructor, set instance level properties etc...
        this.store = new MockDataStore();
    }


    getAll = () => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {
                resolve(Object.assign([], MockDataStore.companies));
            }, delay.value());
        });
    };

    getLandlord = id => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {
                const landlord = _.find(_.flatMap(MockDataStore.companies, c => c.landlordsOrOwners), l => l.id === id);
                resolve(structuredClone(landlord));
            }, delay.value());
        });
    };

    getAllLandlords = () => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {
                const landlords = _.flatMap(MockDataStore.companies, c => c.landlordsOrOwners || []);
                resolve(structuredClone(landlords));
            }, delay.value());
        });
    };

    updateCompany = (companyDoc, companyId) => {

        return new Promise((resolve, reject) => {

            const existingCompanyIndex = _.findIndex(MockDataStore.companies, c => c.id === companyId);

            MockDataStore.companies.splice(existingCompanyIndex, 1); // Remove current version
            MockDataStore.companies.splice(existingCompanyIndex, 0, companyDoc); // Insert new version in its place

            return resolve(companyDoc); // The real API may update this doc.

        });
    };

    updateLandlord = (companyId, landlordData) => {

        const existingCompany = _.find(MockDataStore.companies, c => c.id === companyId);

        if (existingCompany) {

            const existingLandlordIndex = _.findIndex(existingCompany.landlordsOrOwners, l => l.id === landlordData.id);

            if (existingLandlordIndex > -1) {
                existingCompany.landlordsOrOwners.splice(existingLandlordIndex, 1); // Remove current version
                existingCompany.landlordsOrOwners.splice(existingLandlordIndex, 0, landlordData); // Insert new version in its place

                return this.updateCompany(existingCompany, companyId);
            }

            return Promise.reject("Landlord Index not found");
        }

        return Promise.reject("Existing Company not found");
    };

    createCompany = newCompanyDoc => { };
}